export default __webpack_public_path__ + "static/octopus-a8f3a3ec6d01520c534dfdcb0fcdc255.svg";